module.exports = __webpack_public_path__ + "img/cup.372767b2.svg";